import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=c11a4d6e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c11a4d6e')) {
      api.createRecord('c11a4d6e', component.options)
    } else {
      api.reload('c11a4d6e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=c11a4d6e&", function () {
      api.rerender('c11a4d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l7sudHhlg5p9/JS/comp/childrenage.vue"
export default component.exports